import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "fl mr15"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "fs24 fl mr10 ml10 mt20" }, "⇒", -1)
const _hoisted_4 = {
  class: "fl",
  style: {"max-width":"240px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: `keyword_to_blank_`,
  class: "fs13 pointer"
}, " この場所を無視する", -1)
const _hoisted_7 = {
  key: 1,
  class: "fl"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "padw10 fl" }
const _hoisted_13 = {
  key: 0,
  class: "fs12 grey"
}
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.canEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MdTextfieldTag, {
            name: "変換する前のキーワード（部分一致）",
            placeholder: "会議室A",
            style: {"height":"56px","min-width":"240px","max-width":"240px"},
            class: "fl fs14",
            value: _ctx.newconv.before_keyword,
            onInputValue: _ctx.inputConvBeforeKeyword,
            onBlur: _ctx.checkLocationKeyword,
            errMessage: _ctx.failedConvBeforeKeyword ? `場所名を入力してください。` : null,
            required: ""
          }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_ctx.newconv.convert_type != `keyword_to_blank`)
              ? (_openBlock(), _createBlock(_component_MdTextfieldTag, {
                  key: 0,
                  name: "変換した後のキーワード（必須）",
                  placeholder: "東京タワー17F",
                  style: {"height":"56px","min-width":"240px","max-width":"240px"},
                  class: "fl fs14",
                  value: _ctx.newconv.after_keyword,
                  onInputValue: _ctx.inputConvAfterKeyword,
                  onBlur: _ctx.checkLocationKeyword,
                  errMessage: _ctx.failedConvAfterKeyword ? `場所名を入力してください。` : null
                }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]))
              : _createCommentVNode("", true),
            _hoisted_5,
            _createElementVNode("div", {
              class: _normalizeClass(`ml15 fl ${_ctx.newconv.convert_type == `keyword_to_blank` ? `mt30` : ``}`)
            }, [
              _createVNode(_component_CheckboxTag, {
                value: ``,
                name: `keyword_to_blank`,
                checked: _ctx.newconv.convert_type == `keyword_to_blank`,
                prefix: `keyword_to_blank`,
                onClickCheckbox: _ctx.clickKeywordToBlank,
                style: {"margin-left":"1px"}
              }, null, 8, ["checked", "onClickCheckbox"]),
              _createTextVNode("  "),
              _hoisted_6
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.canEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "submit",
            class: "pointer centered circle_button skyblueBg fs16 rad8 ml20 mt15",
            style: {"width":"100px","height":"50px","padding":"14px 8px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveConv && _ctx.saveConv(...args)))
          }, _toDisplayString(_ctx.newconv.id ? `更新` : `作成`), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_8,
    (_ctx.convs)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.convs, (conv, convindex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: convindex,
            class: "borderGrey rad4"
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.selectConv(conv))
            }, [
              (conv.convert_type == `default`)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(`/assets/call/call_mappin_red.png`),
                    height: "60",
                    width: "60",
                    class: "fl"
                  }, null, 8, _hoisted_10))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.$getAssetImageUrl(`/assets/call/call_mappin.png`),
                    height: "60",
                    width: "60",
                    class: "fl"
                  }, null, 8, _hoisted_11)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", {
                  class: _normalizeClass(`fs14 fw600 ${conv.convert_type == `default` ? `` : `mt10`}`)
                }, _toDisplayString(conv.before_keyword) + " ⇒ " + _toDisplayString(conv.convert_type == `default` ? conv.after_keyword : `この場所を利用しません`), 3),
                (conv.convert_type == `default`)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(conv.lat) + ", " + _toDisplayString(conv.lon), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.canEdit)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                    width: "20",
                    height: "23",
                    class: "pointer fr mr15 mt20",
                    onClick: ($event: any) => (_ctx.removeConv(conv))
                  }, null, 8, _hoisted_14))
                : _createCommentVNode("", true),
              _hoisted_15
            ], 8, _hoisted_9),
            _hoisted_16
          ]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}